/* istanbul ignore file */

// main actions
export const main = {
  ADD_INSTANCE: 'ADD_INSTANCE',
  REMOVE_INSTANCE: 'REMOVE_INSTANCE',
  SET_INSTANCE_INDEX: 'SET_INSTANCE_INDEX',
  SET_INSTANCE_LABEL: 'SET_INSTANCE_LABEL',
  CLEAR_ENCRYPTION_KEY: 'CLEAR_ENCRYPTION_KEY',
  SET_NEW_USER: 'SET_NEW_USER',
  ADD_CONTACT: 'ADD_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
};

// tempData actions
export const tempData = {
  SET_STATUS: 'SET_STATUS',
  SET_SHARE_DATA: 'SET_SHARE_DATA',
  // SET_CONNECTION_STATE: 'SET_CONNECTION_STATE',
};
